export default __webpack_public_path__ + "static/media/referral_status_1.98a2e0c8.svg";